
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";

const { dark } = colors;
const { borderWidth, borderColor } = borders;

const stepConnector = {
  styleOverrides: {
    root: {
    
    },

    alternativeLabel: {
     
    },

    line: {
   
    },
  },
};

export default stepConnector;
